import { ImageModel, Nullable } from '@hglobal/common';

export enum SupportCategories {
  platform = 'platform',
  office = 'office',
  education = 'education',
  finance = 'finance',
}

export interface SupportRequest {
  text: string;
  images: ImageModel[];
  source: SupportCategories;
  course: Nullable<number>;
  subject: Nullable<string>;
  financialCategory: Nullable<string>;
  extraInformation: SupportRequestExtraInformation;
}

export interface SupportRequestExtraInformation {
  location_id: Nullable<number>;
  office_space: Nullable<string>;
  office_floor: Nullable<string>;
}
